import enumApi from '@/common/api/enumApi.js'

const state = {
  cardTypes: [],
  cardStates: [],
  payTypes: [],
  paramCodes: [],
  paymentType: [],
  checkedList: [],
  roleTypes: [],
  orderStatus: [],
  payStatus: [],
  payChannels: [],
  tradeTypes: [],
  payWays: [],
  refundTypes: [],
  member_appType: [],
  cardBelongType: [],
  requestSource: [],
  cardRechargeType: []
}

const getters = {
  cardTypes(state) {
    return state.cardTypes
  },
  cardStates(state) {
    return state.cardStates
  },
  payTypes(state) {
    return state.payTypes
  },
  paramCodes(state) {
    return state.paramCodes
  },
  paymentType(state) {
    return state.paymentType
  },
  checkedList(state) {
    return state.checkedList
  },
  roleTypes(state) {
    return state.roleTypes
  },
  orderStatus(state) {
    return state.orderStatus
  },
  payStatus(state) {
    return state.payStatus
  },
  payChannels(state) {
    return state.payChannels
  },
  tradeTypes(state) {
    return state.tradeTypes
  },
  payWays(state) {
    return state.payWays
  },
  refundTypes(state) {
    return state.refundTypes
  },
  member_appType(state) {
    return state.member_appType
  },
  cardBelongType(state) {
    return state.cardBelongType;
  },
  requestSource(state){
    return state.requestSource
  },
  cardRechargeType(state){
    return state.cardRechargeType
  }
}

const mutations = {
  cardTypes(state, cardTypes) {
    state.cardTypes = cardTypes
  },
  cardStates(state, cardStates) {
    state.cardStates = cardStates
  },
  payTypes(state, payTypes) {
    state.payTypes = payTypes
  },
  paramCodes(state, paramCodes) {
    state.paramCodes = paramCodes
  },
  paymentType(state, paymentType) {
    state.paymentType = paymentType
  },
  checkedList(state, checkedList) {
    state.checkedList = checkedList
  },
  roleTypes(state, roleTypes) {
    state.roleTypes = roleTypes
  },
  orderStatus(state, orderStatus) {
    state.orderStatus = orderStatus
  },
  payStatus(state, payStatus) {
    state.payStatus = payStatus
  },
  payChannels(state, payChannels) {
    state.payChannels = payChannels
  },
  tradeTypes(state, tradeTypes) {
    state.tradeTypes = tradeTypes
  },
  payWays(state, payWays) {
    state.payWays = payWays
  },
  refundTypes(state, refundTypes) {
    state.refundTypes = refundTypes
  },
  member_appType(state, member_appType) {
    state.member_appType = member_appType
  },
  cardBelongType(state, cardBelongType) {
    state.cardBelongType = cardBelongType
  },
  requestSource(state,requestSource) {
    state.requestSource = requestSource
  },
  cardRechargeType(state,requestSource) {
    state.cardRechargeType = requestSource
  }
}

const actions = {
  getCardTypes({commit}) {
    console.log('从后台获取 CardTypes')
    return new Promise((resolve, reject) => {
      enumApi.getCardTypes().then(res => {
        if (res && res.length > 0) {
          commit('cardTypes', res)
          resolve(res)
        } else {
          resolve([])
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  getCardStates({commit}) {
    console.log('从后台获取 CardStates')
    return new Promise((resolve, reject) => {
      enumApi.getCardStates().then(res => {
        if (res && res.length > 0) {
          commit('cardStates', res)
          resolve(res)
        } else {
          resolve([])
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  getPaymentType({commit}) {
    console.log('从后台获取 payTypes')
    return new Promise((resolve, reject) => {
      enumApi.getPaymentType().then(res => {
        if (res && res.length > 0) {
          commit('payTypes', res)
          resolve(res)
        } else {
          resolve([])
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  getParamCode({commit}) {
    console.log('从后台获取 paramCodes')
    return new Promise((resolve, reject) => {
      enumApi.getParamCode().then(res => {
        if (res && res.length > 0) {
          commit('paramCodes', res)
          resolve(res)
        } else {
          resolve([])
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  getPayment({commit}) {
    console.log('getPayment')
    return new Promise((resolve, reject) => {
      enumApi.getPayment().then(res => {
        if (res && res.length > 0) {
          commit('paymentType', res)
          resolve(res)
        } else {
          resolve([])
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  getChecked({commit}) {
    console.log('从后台获取 checkedList')
    return new Promise((resolve, reject) => {
      enumApi.getChecked().then(res => {
        if (res && res.length > 0) {
          commit('checkedList', res)
          resolve(res)
        } else {
          resolve([])
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  getRoleTypes({commit}) {
    console.log('从后台获取 roleTypes')
    return new Promise((resolve, reject) => {
      enumApi.getRoleTypes().then(res => {
        if (res && res.length > 0) {
          commit('roleTypes', res)
          resolve(res)
        } else {
          resolve([])
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  getOrderStatus({commit}) {
    console.log('从后台获取 orderStatus')
    return new Promise((resolve, reject) => {
      enumApi.getOrderStatus().then(res => {
        if (res && res.length > 0) {
          commit('orderStatus', res)
          resolve(res)
        } else {
          resolve([])
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  getPayStatus({commit}) {
    console.log('从后台获取 payStatus')
    return new Promise((resolve, reject) => {
      enumApi.getPayStatus().then(res => {
        if (res && res.length > 0) {
          commit('payStatus', res)
          resolve(res)
        } else {
          resolve([])
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  getPayChannelEnum({commit}) {
    console.log('从后台获取 payChannels')
    return new Promise((resolve, reject) => {
      enumApi.getPayChannelEnum().then(res => {
        if (res && res.length > 0) {
          commit('payChannels', res)
          resolve(res)
        } else {
          resolve([])
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  getTradeTypeEnum({commit}) {
    console.log('从后台获取 tradeTypes')
    return new Promise((resolve, reject) => {
      enumApi.getTradeTypeEnum().then(res => {
        if (res && res.length > 0) {
          commit('tradeTypes', res)
          resolve(res)
        } else {
          resolve([])
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  getPayWayEnum({commit}) {
    console.log('从后台获取 payWays')
    return new Promise((resolve, reject) => {
      enumApi.getPayWayEnum().then(res => {
        if (res && res.length > 0) {
          commit('payWays', res)
          resolve(res)
        } else {
          resolve([])
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  getRefundTypeEnum({commit}) {
    console.log('从后台获取 refundTypes')
    return new Promise((resolve, reject) => {
      enumApi.getRefundTypeEnum().then(res => {
        if (res && res.length > 0) {
          commit('refundTypes', res)
          resolve(res)
        } else {
          resolve([])
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  getMemberAppType({commit}) {
    console.log('从后台获取 AppType')
    return new Promise((resolve, reject) => {
      enumApi.getMemberAppType().then(res => {
        if (res && res.length > 0) {
          commit('member_appType', res)
          resolve(res)
        } else {
          resolve([])
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  getCardBelongType({commit}) {
    console.log('从后台获取 cardBelongType')
    return new Promise((resolve, reject) => {
      enumApi.getCardBelongType().then(res => {
        if (res && res.length > 0) {
          commit('cardBelongType', res)
          resolve(res)
        } else {
          resolve([])
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  getRequestSource({commit}) {
    //console.log('从后台获取 getRequestSource')
    return new Promise((resolve, reject) => {
      enumApi.getRequestSource().then(res => {
        if (res && res.length > 0) {
          commit('requestSource', res)
          resolve(res)
        } else {
          resolve([])
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  getCardRechargeType({commit}) {
    console.log('从后台获取 cardRechargeType')
    return new Promise((resolve, reject) => {
      enumApi.getCardRechargeTypeEnum().then(res => {
        if (res && res.length > 0) {
          commit('cardRechargeType', res)
          resolve(res)
        } else {
          resolve([])
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/enums.js